import { useSanityContext } from '@/sanity/SanityDataProvider';
import type { ContactInfoData, ContactSectionData } from '@/sanity/types';

const FALLBACK_WA = 'https://wa.me/34669375242?text=Hola%20INBOCA%2C%20me%20gustaría%20obtener%20más%20información';

// R3 - Pure resolver for contact info fields (keeps complexity < 10)
function resolveContactInfo(ci: ContactInfoData | undefined) {
  return {
    email: ci?.email ?? 'Inbocaconsulting@gmail.com',
    phone: ci?.phone ?? '+34 669 375 242',
    phoneRaw: ci?.phoneRaw ?? '+34669375242',
    address: ci?.address ?? 'Polígono Romica calle 4/5 bis (Albacete)',
    whatsappNumber: ci?.whatsappNumber ?? '34669375242',
    whatsappUrl: ci
      ? `https://wa.me/${ci.whatsappNumber}?text=${encodeURIComponent(ci.whatsappDefaultMessage)}`
      : FALLBACK_WA,
  };
}

// R3 - Pure resolver for contact section text (keeps complexity < 10)
function resolveContactSection(cs: ContactSectionData | undefined) {
  return {
    pageTitle: cs?.title ?? 'Contáctanos',
    pageDesc: cs?.description ?? 'Estamos aquí para ayudarte. Elige tu canal preferido de comunicación.',
    formTitle: cs?.formTitle ?? 'Formulario de Consulta',
    formDesc: cs?.formDescription ?? 'Completa el formulario y nos pondremos en contacto',
  };
}

/**
 * R2 - Composes resolved contact data from Sanity context
 * R3 - Delegates to pure resolvers to stay under complexity limit
 */
export function useContactPageData() {
  const { data } = useSanityContext();

  return {
    ...resolveContactInfo(data?.contactInfo),
    ...resolveContactSection(data?.contact),
    footer: data?.footer,
    contactInfo: data?.contactInfo,
  };
}
